export enum HTTP_ERROR {
  HTTP_STATUS_CODE_EXCLUDE = 'http-status-code-exclude',
}
